module.exports = __webpack_public_path__ + "static/img/3A.323f79c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LOGO/3A.png
// module id = +hVX
// module chunks = 1